import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PencilButtonComponent } from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { PencilIconComponent } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export enum ColorScheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}
@Component({
  selector: 'app-pencil-bottom-sheet-container',
  standalone: true,
  imports: [CommonModule, PencilButtonComponent, PencilIconComponent, TranslateModule],
  templateUrl: './pencil-bottom-sheet-container.component.html',
  styleUrls: ['./pencil-bottom-sheet-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PencilBottomSheetContainerComponent {
  @Input() title: string = this.translate.instant('More');
  @Input() hasArrowBack = false;
  @Input() colorScheme: ColorScheme = ColorScheme.DARK;
  @Input()
  @HostBinding('class.fullscreen')
  fullscreen = false;
  @Output() closeClicked = new EventEmitter<void>();
  @Output() backClicked = new EventEmitter<void>();

  public ColorScheme = ColorScheme;

  @HostBinding('class.light-scheme')
  get isLightScheme(): boolean {
    return this.colorScheme === ColorScheme.LIGHT;
  }

  constructor(private translate: TranslateService) {}

  handleClose(): void {
    this.closeClicked.emit();
  }

  handleArrowBackClick(): void {
    this.backClicked.emit();
  }
}
